/* eslint-disable */
import React, { useState } from "react";
import { Modal, Button, Select, Typography, message } from "antd";
import { useSelector } from "react-redux";

const { Text } = Typography;

export const TransferLead = ({
  onTransfer,
  setPopoverVisible,
  currentUser,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const { users } = useSelector((state) => state.users);

  const userOptions =
    users
      ?.filter((u) => u.id !== currentUser?.id)
      .map((u) => ({
        label: `${u.first_name} ${u.last_name}`,
        value: u.id,
      })) || [];

  const handleTransferClick = () => {
    if (!selectedUser) {
      message.warning("Please select a user");
      return;
    }

    onTransfer(selectedUser);
    setOpen(false);
  };

  return (
    <>
      <Button
        type="link"
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        disabled={disabled}
        onClick={() => {
          setPopoverVisible(false);
          setOpen(true);
        }}
      >
        Transfer Lead
      </Button>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={450}
        title={
          <Text strong style={{ fontSize: 18 }}>
            Transfer Lead
          </Text>
        }
      >
        <div style={{ marginBottom: 16 }}>
          <Text>Select a user to transfer this lead:</Text>
        </div>

        <Select
          style={{ width: "100%", marginBottom: 16 }}
          placeholder="Select User"
          options={userOptions}
          value={selectedUser}
          onChange={setSelectedUser}
        />

        <Button
          type="primary"
          block
          disabled={!selectedUser}
          onClick={handleTransferClick}
        >
          Transfer
        </Button>
      </Modal>
    </>
  );
};
